__turbopack_context__.v({
  "UiBadge": "badge-module__lPrjPq__UiBadge",
  "UiBadge__label": "badge-module__lPrjPq__UiBadge__label",
});
